import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SectionTitle, Text } from "../../components/styledComponent";
import styles from "./style.module.scss";

const TermsAndCondition = () => {
  return (
    <div className={styles.termsConditionPage}>
      <Container className={`sectionContainer`}>
        <Row className={styles.pageTitle}>
          <Col>
            <SectionTitle $textAlign="center">
              Terms and Conditions of Online Service
            </SectionTitle>
          </Col>
        </Row>

        {/* Section 1: Introduction */}
        <Row>
          <Col>
            <h3>1. Introduction</h3>
            <Text>
              <b>1.1.</b> These Terms and Conditions of Online Service govern
              your use of websites, mobile applications, or other online
              platforms or services owned or operated by Canco Petroleum Ltd. or
              its affiliates or subsidiaries (collectively, "<b>Canco</b>"),
              including third-party platforms where interactions between you and
              Canco occur (collectively, the "<b>Online Services</b>").
              <br />
              <br />
              <b>1.2.</b> The "<b>Online Services</b>" are available subject to
              compliance with these Terms and Conditions of Online Service and
              Canco's Privacy Policy (the "<b>Privacy Policy</b>"), which
              together are collectively referred to as the "<b>Terms</b>".
              <br />
              <br />
              <b>1.3.</b> By accessing or using the "<b>Online Services</b>",
              you agree to be bound by and comply with the "<b>Terms</b>".
              <br />
              <br />
              <b>1.4.</b> You represent that you understand and can agree with
              the "<b>Terms</b>".
              <br />
              <br />
              <b>1.5.</b> If you do not agree to be bound by and comply with the
              "<b>Terms</b>", you are not permitted to access or use the "
              <b>Online Services</b>".
            </Text>
          </Col>
        </Row>

        {/* Section 2: Permitted Uses */}
        <Row>
          <Col>
            <h3>2. Permitted Uses</h3>
            <Text>
              <b>2.1.</b> The "<b>Online Services</b>" may contain information,
              data, numerical figures, advertisements, and other written
              materials (collectively, the "<b>Material</b>").
              <br />
              <br />
              <b>2.2.</b> The "<b>Material</b>" is provided solely for
              informational purposes.
              <br />
              <br />
              <b>2.3.</b> You may access and use the "<b>Online Services</b>",
              including the "<b>Material</b>", only in accordance with all
              applicable laws and the "<b>Terms</b>".
              <br />
              <br />
              <b>2.4.</b> Canco grants you a non-exclusive, non-transferable,
              and revocable license to access and use the "<b>Online Services</b>
              " and the "<b>Material</b>" solely for the following purposes:
              displaying, saving on a personal computer, downloading, or
              printing a copy of the Material for personal use, provided that
              the Material is not modified by you (the "Permitted Uses"). By
              accessing, using, displaying, saving, downloading, or printing the
              "<b>Online Services</b>" or the "<b>Material</b>", you do not
              acquire any additional rights or licenses to the "<b>Online
              Services</b>" or the "<b>Material</b>" beyond the Permitted Uses.
              <br />
              <br />
              <b>2.5.</b> The "<b>Online Services</b>" may provide links to other
              parties' websites.
              <br />
              <br />
              <b>2.6.</b> Any content on websites linked to, or potentially
              linked from, the "<b>Online Services</b>" is not provided by or
              under the control of Canco. If you choose to access any such
              website, you do so entirely at your own risk.
              <br />
              <br />
              <b>2.7.</b> Canco does not endorse any content found on websites
              linked to, or potentially linked from, the "<b>Online Services</b>
              ". Canco disclaims any representation, warranty, or guarantee
              concerning the quality, accuracy, reliability, completeness,
              currency, timeliness, non-infringement, or fitness for any
              particular purpose of such websites or their content.
            </Text>
          </Col>
        </Row>

        {/* Section 3: Prohibited Activities */}
        <Row>
          <Col>
            <h3>3. Prohibited Activities</h3>
            <Text>
              <b>3.1.</b> You shall not access or use the "<b>Online Services</b>
              ", including the "<b>Material</b>", in any way or for any purpose
              that is unlawful.
              <br />
              <br />
              <b>3.2.</b> Without Canco's prior written consent, you shall not
              access or use the "<b>Online Services</b>", including the "
              <b>Material</b>", for any purpose that violates Canco's rights or
              any other person's rights, or for any purpose outside the scope of
              the Permitted Uses.
              <br />
              <br />
              <b>3.3.</b> Without limiting the generality of the foregoing and
              without such consent, you shall not use any portion of the "
              <b>Online Services</b>", including the "<b>Material</b>", to:
              <ul className={styles.infoList}>
                <li>
                  <b>(a)</b> Make available, distribute, display, post,
                  disseminate, publish, republish, retransmit, communicate, or
                  broadcast to the public.
                </li>
                <li>
                  <b>(b)</b> Create a derivative work, modify, translate,
                  select, arrange, merge, compile, or otherwise combine the "
                  <b>Online Services</b>" (including the "<b>Material</b>")
                  with other data or content.
                </li>
                <li>
                  <b>(c)</b> Scrape (including online screen scraping and
                  database scraping), or engage in any other activity intended to
                  collect, store, reorganize, summarize, or manipulate any of the
                  "<b>Material</b>", whether by automatic programming or
                  otherwise.
                </li>
                <li>
                  <b>(d)</b> Sell, license, sublicense, or engage in any other
                  commercial transaction relating to the "<b>Online Services</b>"
                  (including the "<b>Material</b>"), or reproduce all or any
                  portion thereof in any medium.
                </li>
                <li>
                  <b>(e)</b> Decompile, disassemble, reverse engineer, or
                  perform any other exploitation of the "<b>Online Services</b>
                  ", including the "<b>Material</b>"'s architecture or underlying
                  software or code.
                </li>
                <li>
                  <b>(f)</b> Engage in any activity that is outside the scope of
                  activity permitted by the "<b>Terms</b>".
                </li>
              </ul>
            </Text>
          </Col>
        </Row>

        {/* Section 4: Copyright */}
        <Row>
          <Col>
            <h3>4. Copyright</h3>
            <Text>
              <b>4.1.</b> You acknowledge that the "<b>Material</b>" is
              protected by copyright or otherwise owned by, or licensed to,
              Canco, including without limitation all:
              <ul className={styles.infoList}>
                <li>
                  <b>(a)</b> text, data and other literary works;
                </li>
                <li>
                  <b>(b)</b> logos, designs, graphics, images, photographs,
                  artwork and other artistic works;
                </li>
                <li>
                  <b>(c)</b> musical works and other sounds;
                </li>
                <li>
                  <b>(d)</b> videos and all audio-visual works;
                </li>
                <li>
                  <b>(e)</b> performances;
                </li>
                <li>
                  <b>(f)</b> other materials;
                </li>
                <li>
                  <b>(g)</b> selections, arrangements, compilations,
                  modifications and enhancements of all of the foregoing;
                </li>
                <li>
                  <b>(h)</b> software, including program code that may execute
                  on the "<b>Online Services</b>"' servers or that may be
                  embedded or be downloadable from individual webpages on the "
                  <b>Online Services</b>"; and
                </li>
                <li>
                  <b>(i)</b> the architecture and layout of websites and
                  webpages thereon.
                </li>
              </ul>
            </Text>
          </Col>
        </Row>

        {/* Section 5: Risks You Assume */}
        <Row>
          <Col>
            <h3>5. Risks You Assume</h3>
            <Text>
              <b>5.1.</b> You acknowledge that your access to, use of, or
              downloading of, the "<b>Online Services</b>", including without
              limitation the "<b>Material</b>", is done at your own risk.
              <br />
              <br />
              <b>5.2.</b> Canco does not represent, warrant, or guarantee that
              the "<b>Online Services</b>", including without limitation the "
              <b>Material</b>", is compatible with any computer system or free
              of viruses, worms, trojan horses, or disabling devices or other
              code that has harmful effects, including without limitation any
              contaminating or destructive properties.
              <br />
              <br />
              <b>5.3.</b> You acknowledge that you are responsible for
              implementing safeguards to protect the security and integrity of
              your computer system and mobile system.
              <br />
              <br />
              <b>5.4.</b> You acknowledge that you are responsible for the
              entire cost of any service, repairs to your computer system that
              may be necessary as a result of your access to, and use of, the "
              <b>Online Services</b>" including without limitation the "
              <b>Material</b>".
            </Text>
          </Col>
        </Row>

        {/* Section 6: Limitation of Liability */}
        <Row>
          <Col>
            <h3>6. Limitation of Liability</h3>
            <Text>
              <b>6.1.</b> THE "<b>ONLINE SERVICES</b>", INCLUDING WITHOUT
              LIMITATION THE "<b>MATERIAL</b>", ARE PROVIDED "AS IS" WITHOUT
              WARRANTY OR CONDITION OF ANY KIND. ACCESS TO, AND USE OF, THE "
              <b>ONLINE SERVICES</b>" OR THE "<b>MATERIAL</b>" IS AT YOUR OWN
              RISK.
              <br />
              <br />
              <b>6.2.</b> CANCO DOES NOT MAKE ANY REPRESENTATION, WARRANTY OR
              CONDITION ABOUT THE QUALITY, ACCURACY, RELIABILITY, COMPLETENESS,
              CURRENCY, TIMELINESS, MERCHANTABILITY, FITNESS FOR A PARTICULAR
              PURPOSE OR NON-INFRINGEMENT OF INTELLECTUAL PROPERTY OR RELATED
              RIGHTS, OF THE "<b>ONLINE SERVICES</b>" OR THE "<b>MATERIAL</b>".
              <br />
              <br />
              <b>6.3.</b> CANCO DOES NOT ASSUME ANY RESPONSIBILITY FOR ANY
              ERRORS, OMISSIONS OR INACCURACIES IN THE "<b>ONLINE SERVICES</b>"
              OR THE "<b>MATERIAL</b>".
              <br />
              <br />
              <b>6.4.</b> TO THE FULLEST EXTENT PERMITTED BY LAW, CANCO
              DISCLAIMS ALL WARRANTIES, REPRESENTATIONS AND CONDITIONS OF ANY
              KIND WITH RESPECT TO THE "<b>ONLINE SERVICES</b>" AND THE "
              <b>MATERIAL</b>" WHETHER EXPRESS, IMPLIED, OR COLLATERAL,
              INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES AND CONDITIONS
              OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
              NON-INFRINGEMENT OF INTELLECTUAL PROPERTY, AND RELATED RIGHTS, OR
              THAT THE "<b>ONLINE SERVICES</b>" OR THE "<b>MATERIAL</b>" ARE OR
              WILL BE ERROR-FREE OR WILL OPERATE WITHOUT INTERRUPTION.
              <br />
              <br />
              <b>6.5.</b> IN NO EVENT WILL CANCO BE LIABLE FOR ANY DAMAGES,
              WHETHER BASED ON WARRANTY, CONTRACT, TORT, NEGLIGENCE, STRICT
              LIABILITY, OR ANY OTHER LEGAL THEORY, INCLUDING WITHOUT LIMITATION
              DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY,
              PUNITIVE DAMAGES, LOST PROFITS, LOSS OF USE, LOSS OF DATA,
              PERSONAL INJURY, FINES, FEES, PENALTIES OR OTHER LIABILITIES,
              WHETHER OR NOT CANCO IS ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGES, RESULTING FROM THE USE OF, OR THE INABILITY TO MAKE USE
              OF, THE "<b>ONLINE SERVICES</b>" OR THE "<b>MATERIAL</b>".
            </Text>
          </Col>
        </Row>

        {/* Section 7: General */}
        <Row>
          <Col>
            <h3>7. General</h3>
            <Text>
              <b>7.1.</b> The "<b>Terms</b>", including any documents
              referenced herein, constitute the entire agreement between you and
              Canco pertaining to the subject matter hereof. The "<b>Terms</b>"
              supersede all prior or contemporaneous communications and
              proposals, whether electronic, oral, or written, between you and
              Canco with respect to the "<b>Online Services</b>", including
              without limitation the "<b>Material</b>".
              <br />
              <br />
              <b>7.2.</b> A printed version of the "<b>Terms</b>" and of any
              notice given in electronic form will be admissible in judicial
              administrative or arbitral proceedings based upon or relating to
              the "<b>Terms</b>" to the same extent and subject to the same
              conditions as other business documents and records originally
              generated and maintained in printed form.
              <br />
              <br />
              <b>7.3.</b> Any failure by Canco to insist upon or enforce strict
              performance of any provision of the "<b>Terms</b>" will not be
              construed as a waiver of any provisions or right.
              <br />
              <br />
              <b>7.4.</b> If any of the provisions contained in the "<b>Terms</b>
              " are determined to be void, invalid, or otherwise unenforceable
              by an arbitrator or court of competent jurisdiction, such
              determination shall not affect the remaining provisions contained
              herein or the affected provision in a jurisdiction outside the
              jurisdiction of such court.
            </Text>
          </Col>
        </Row>

        {/* Section 8: Disputes */}
        <Row>
          <Col>
            <h3>8. Disputes</h3>
            <Text>
              <b>8.1.</b> Canco may seek interim, temporary, or permanent
              injunctions and such other and further relief as a court may deem
              just and proper in the event of a breach or violation of the "
              <b>Terms</b>" or any infringement of Canco's intellectual property,
              privacy, or other rights, resulting in immediate or irreparable
              harm. You consent to the jurisdiction of the courts of the
              Province of British Columbia and the Federal Court of Canada for
              any such action or proceeding, and agree not to initiate any
              action or proceeding except in Kelowna, British Columbia, Canada.
            </Text>
          </Col>
        </Row>

        {/* Section 9: Governing Law */}
        <Row>
          <Col>
            <h3>9. Governing Law</h3>
            <Text>
              <b>9.1.</b> The interpretation, validity, effect and enforcement
              of the "<b>Terms</b>" are governed by the laws of the Province of
              British Columbia and the laws of Canada applicable therein. These
              laws apply to the access and use of the "<b>Online Services</b>",
              including the "<b>Material</b>", regardless of any conflicts of
              laws principles, your domicile, residency, physical location, or
              the location of any Canco office, retail location, or Canco
              personnel with whom you communicate or deal.
              <br />
              <br />
              <b>9.2.</b> The "<b>Online Services</b>", including the "
              <b>Material</b>", are intended for use only in jurisdictions where
              they can be lawfully provided.
            </Text>
          </Col>
        </Row>

        {/* Section 10: Amendments */}
        <Row>
          <Col>
            <h3>10. Amendments</h3>
            <Text>
              <b>10.1.</b> Canco reserves the right to amend or otherwise update
              or modify the "<b>Terms</b>" at any time.
              <br />
              <br />
              <b>10.2.</b> By accessing or using the Services after any updates
              or modifications of the "<b>Terms</b>", you agree to be bound by,
              and comply with, the "<b>Terms</b>" then posted. If any amendment
              or other modification is not acceptable to you, you must cease
              accessing and using the "<b>Online Services</b>", including without
              limitation the "<b>Material</b>".
            </Text>
          </Col>
        </Row>

        {/* Last Revised Date */}
        <Row>
          <Col>
            <Text style={{ marginTop: "3rem", fontStyle: "italic" }}>
              <b>Last revised:</b> November 18, 2025
            </Text>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsAndCondition;
